<template>
  <div class="notices-container" v-if="!loading">
    <p style=";text-autospace:ideograph-numeric;text-align:center;line-height:27px">
      <strong><span style=";font-family:宋体;font-size:24px">单方</span></strong
      ><strong><span style=";font-family:宋体;font-size:24px">解除</span></strong
      ><strong><span style=";font-family:宋体;font-size:24px">协议通知书</span></strong>
    </p>
    <p style=";text-autospace:ideograph-numeric;line-height:150%">
      <strong><span style=";font-family:宋体;line-height:150%;font-size:14px">&nbsp;</span></strong>
    </p>
    <p style=";text-autospace:ideograph-numeric;line-height:150%">
      <strong><span style=";font-family:宋体;line-height:150%;font-size:14px">致：</span></strong>
    </p>
    <p style=";text-autospace:ideograph-numeric;line-height:150%">
      <strong
        ><span style=";font-family:宋体;line-height:150%;font-size:14px"
          ><span style="font-family:宋体">{{ data.name }}</span> &nbsp;&nbsp;&nbsp;</span
        ></strong
      >
    </p>
    <p style="text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style=";font-family:宋体;line-height:150%;font-size:14px"
        ><span style="font-family:宋体">双方于签署的《保险经纪从业人员聘任协议》（下称</span>
        <span style="font-family:宋体"
          >“原协议”）第十条关于协议解除的约定，现因您存在约定的单方解除情形，我司依据原协议行使单方解除权，特此向您发出本解除通知，具体内容如下：</span
        ></span
      >
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-size:14px">一、</span><span style=";font-family:宋体;line-height:150%;font-size:14px">原协议第十条第四款明确约定</span
      ><strong
        ><span style=";font-family:宋体;line-height:150%;font-size:14px"
          ><span style="font-family:宋体">，</span
          ><span style="font-family:宋体">“乙方存在连续 3 个月内无业务或未达到甲方合作业务要求等情形时，甲方有权单方解除合同并注销乙方从业资格</span></span
        ></strong
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">”。</span>
    </p>
    <p style="text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style=";font-family:宋体;line-height:150%;font-size:14px"
        ><span style="font-family:宋体">事实情形：经我司核查，您连续</span>
        <span style="font-family:宋体">3 个月无任何保险业务成交，已满足单方解除条件。</span></span
      >
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-size:14px">二、</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px"
        >本《单方解除协议通知书》自送达之日起即时生效，双方签署的原协议随之解除，我司将自生效之日起七日内注销您的保险经纪从业资格。</span
      ><strong><span style=";font-family:宋体;line-height:150%;font-size:14px">（因保</span></strong
      ><strong
        ><span style=";font-family:宋体;line-height:150%;font-size:14px"
          >险业务特殊性，对于您在合作期间产生的业务出现任何违规或业务品质问题（包括但不限于退保、投诉、继续率等），我司仍有权选择依据原协议相关品质条款、追责及本协议约定向您追偿）</span
        ></strong
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">。</span>
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-weight:bold;font-size:14px">三、</span
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">如您合作期间业务</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">涉及到相关投诉、举报、追责、诉讼等事宜案件，需</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">积极</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">配合</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">我司</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">完成</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">相关</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">案件调查处理</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">，</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">并承担相应的后果</span></strong
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">。</span>
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-size:14px">四、</span><span style=";font-family:宋体;line-height:150%;font-size:14px">原协议解除后</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">，</span><span style=";font-family:宋体;line-height:150%;font-size:14px">您</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">不得再以</span><span style=";font-family:宋体;line-height:150%;font-size:14px">我司</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px"
        >经纪人的名义从事任何保险销售业务，且不得以任何形式将客户信息及公司商业秘密泄露给他人，如有违反，</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">您</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">需承担相应责任并赔偿损失</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">。</span>
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-size:14px">五、</span><span style=";font-family:宋体;line-height:150%;font-size:14px">您</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">在从事保险经纪人期间严格</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">遵守</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">公司和监管的各项要求，</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">认真审</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">核客户信息，保证客户信息的合法</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">、</span><span style=";font-family:宋体;line-height:150%;font-size:14px">真实</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">、</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px"
        >完整，销售过程无任何瑕疵和违法违规行为，不存在任何侵害公司、合作单位和保险消费者权益的行为，否则</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">我司有权向您追偿相关损失</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">。</span>
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-weight:bold;font-size:14px">六、</span
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">您了解并清楚原协议解除后，我司无法也不再向您支付任何手续费</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">。</span></strong>
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-size:14px">七、</span><span style=";font-family:宋体;line-height:150%;font-size:14px">原</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">协议</span><span style=";font-family:宋体;line-height:150%;font-size:14px">解除</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">后，对于双方合作期间</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">的业务所需提供服务或由于双方合作期间的业务导致的相关第三方纠纷，您</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">仍须</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">配合我司积极解决，否则如给我司造成损失的，我司有权要求赔偿。</span>
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-size:14px">八、</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">本通知书条款若与原协议存在冲突，以本通知书为准。</span>
    </p>
    <p style="margin-left:0;text-indent:28px;text-autospace:ideograph-numeric;line-height:150%">
      <span style="font-family:宋体;font-size:14px">九、</span
      ><span style=";font-family:宋体;line-height:150%;font-size:14px">如您在收到本通知书后，有任何异议，应在三日内及时反馈。</span>
    </p>
    <p style=";text-autospace:ideograph-numeric;text-align:center;line-height:150%">
      <span style=";font-family:宋体;line-height:150%;font-size:14px">&nbsp;</span>
    </p>
    <p style="margin-top:7px;margin-bottom:7px;text-autospace:ideograph-numeric;text-align:right;line-height:150%">
      <strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">甲方：</span></strong
      ><strong><span style="font-family: 宋体;line-height: 150%;font-size: 14px">梧桐树保险经纪有限公司</span></strong>
    </p>
    <p
      class="date-text"
      style="font-family: 宋体;font-size: 14px;margin-top:7px;margin-bottom:7px;text-autospace:ideograph-numeric;text-align:right;line-height:150%"
    >
      <strong>日期：2025年11月10号</strong>
    </p>
    <p>
      <br />
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: '',
      loading: true
    };
  },
  created() {
    this.loading = true;
    this.$http({
      type: 'GET',
      url: '/api/userBase/queryById',
      data: {
        id: this.$route.query.id
      }
    }).then(res => {
      this.data = res.data;
      this.loading = false;
    });
  }
};
</script>

<style scoped lang="scss">
.notices-container {
  padding: 30px;
  p {
    margin-bottom: 0.7em;
  }
}
</style>
